import type { IReportStoragePort } from '@reports/application/ports';
import type { FiltersMetadata } from '@reports/infrastructure/repositories/types';

/**
 * Use case to save filters metadata to storage
 *
 * @param storagePort - Storage port implementation
 * @returns Use case with execute method
 */
export const saveFiltersMetadataUseCase = (storagePort: IReportStoragePort) => {
  const execute = async (metadata: FiltersMetadata): Promise<void> => {
    await storagePort.saveFiltersMetadata(metadata);
  };

  return { execute };
};
